/**
 * This converts participant portal's format of storing information about data that is being loaded
 * into the format expected by the ssg-forms LoadingPane
 * @param {object} loadingState the state of some information that is being loaded
 */
export function convertLoadingState(loadingState) {
  const { err, isFetching, data } = loadingState || { err: null, isFetching: false, isValid: false, data: null};
  return {
    isLoading: isFetching,
    data,
    error: !!err ? {
      alertLevel: 'error',
      errorCode: err.errorCode,
      errorMessage: err.errorMessage
    } : null
  }
}
